import ActionSuccessToast from '../ActionSuccessToast'
import { useRef, useState } from 'react'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../hooks/useAuth'
import { saveSetupDetails } from '../../lib/setupDetails'

export default function SetupDetailsEditor({ project, onSaved }) {
  const { user } = useAuth()
  const [baseline, setBaseline] = useState(project)
  const [name, setName] = useState(project.setup_pattern || '')
  const [note, setNote] = useState(project.setup_notes || '')
  const [pending, setPending] = useState(false)
  const [status, setStatus] = useState('')
  const [error, setError] = useState('')
  const saving = useRef(false)
  const canSave = user?.id === project.user_id
  const save = async () => {
    if (saving.current || !canSave) return
    saving.current = true
    setPending(true)
    setError('')
    setStatus('')
    try {
      const saved = await saveSetupDetails(supabase, user.id, baseline, { name, note })
      setBaseline({ ...baseline, ...saved })
      setName(saved.setup_pattern || '')
      setStatus('Details saved')
      try { await onSaved?.(saved) } catch { setStatus('Details saved. Refresh to update the card.') }
    } catch (failure) { setError(failure.message) }
    finally { saving.current = false; setPending(false) }
  }
  const inputClass = 'w-full rounded border border-border bg-canvas2 px-2 py-1 font-mono text-[11px] text-ink'
  return <div className="space-y-2" onClick={event => event.stopPropagation()}>
    <label className="block font-mono text-[10px] text-inkMuted">Setup name
      <input aria-label="Setup name" value={name} disabled={pending} onChange={event => { setName(event.target.value); setStatus('') }} className={inputClass} />
    </label>
    <label className="block font-mono text-[10px] text-inkMuted">Setup note
      <textarea aria-label="Setup note" rows={3} value={note} disabled={pending} onChange={event => { setNote(event.target.value); setStatus('') }} placeholder="Thoughts, thesis, or reminders…" className={inputClass} />
    </label>
    <button type="button" disabled={pending || !canSave} onClick={save} className="rounded border border-border px-3 py-1.5 font-mono text-[10px] text-ink disabled:opacity-40">{pending ? 'Saving…' : 'Save details'}</button>
    <ActionSuccessToast message={status} onDismiss={() => setStatus('')} />
    {error && <div role="alert" className="font-mono text-[10px] text-ember">{error}</div>}
  </div>
}
